var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSq1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.096 279.719L292.691 450.002 207.491 450.002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.823 250.008L449.989 207.482 449.989 292.524z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.096 220.298L207.541 50.222 292.637 50.222z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.368 250.008L49.989 292.579 49.989 207.429z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.13 227.762L319.764 50.001 449.989 50.001 449.989 180.151 449.989 180.565 272.13 228.208"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.836 227.996L49.989 180.362 49.989 50.222 180.183 50.222 180.621 50.222 228.283 227.996"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.13 272.246L319.764 450.002 449.989 450.002 449.989 319.88 449.989 319.437 272.13 271.813"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.836 272.029L49.989 319.662 49.989 449.784 180.183 449.784 180.621 449.784 228.283 272.029"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSq1);
export default __webpack_public_path__ + "static/media/sq1.571aad0537f18279e2476338619b0a34.svg";
export { ForwardRef as ReactComponent };